// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCd3PotP_Ofzw2KWBnb7hC-C0VJuMfH85I",
  authDomain: "fraserhealth-4921b.firebaseapp.com",
  databaseURL: "https://fraserhealth-4921b-default-rtdb.firebaseio.com",
  projectId: "fraserhealth-4921b",
  storageBucket: "fraserhealth-4921b.appspot.com",
  messagingSenderId: "426141299167",
  appId: "1:426141299167:web:c5271f838d378aa455146a",
  measurementId: "G-7CWXZCE7VD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

export { app, database, auth };